__turbopack_context__.v({
  "avatar": "CreatorInfo-module-scss-module__KWxYCG__avatar",
  "textContainer": "CreatorInfo-module-scss-module__KWxYCG__textContainer",
  "underline": "CreatorInfo-module-scss-module__KWxYCG__underline",
});
